import languages from '@/configs/languages.json';

export const getLanguageList = (searchValue?: string): LanguageT[] => {
  const languageList = languages as LanguageT[];
  if (!searchValue) return languageList;
  return languageList.filter(
    (language) =>
      language.name.toLowerCase().includes(searchValue.toLowerCase()) ||
      language.code.toLowerCase().includes(searchValue.toLowerCase()),
  );
};

export const getIntlDisplayNameBuilder = () => {
  return new Intl.DisplayNames(['en'], {
    type: 'language',
  });
};
